<template>
<div id="page-login" class="container text-center">
    <div class="gradient-overlay"></div>
    <div class="content row login" v-if="isLogin">
        <div class="col-sm-12">
            <h1><b>Sound</b>Feed</h1>
            <h2>&mdash; LOGIN &mdash;</h2>
        </div>

        <div class="col-sm-12 form-container">
            <div class="input-field email-field">
                <input v-model="credentials.email" @keyup.enter="login" id="email" type="text" class="text-input" autocomplete="off">
                <label for="email" id="email-label" :data-error="getError('email')" class="input-label active">{{ emailLabel }}</label>
            </div>

            <div class="input-field">
                <input v-model="credentials.password" @keyup.enter="login" id="password" type="password" class="text-input" autocomplete="off">
                <label for="password" id="password-label" :data-error="getError('password')" class="input-label active">{{ passwordLabel }}</label>
            </div>
        </div>

        <div class="col-sm-12">
            <div v-show="!loading" @click="login" class="btn btn-block btn-login">LOG IN</div>
            <div v-show="loading" class="btn btn-block btn-loading disabled">
                <loader color="ripple-light" size="128px"></loader>
            </div>
        </div>

        <div class="col-sm-12">
            <p class="forgot-password">
                <a @click="isLogin = false">Forgot your password?</a>
            </p>
            <span style="color: #0002;">{{ credentials.device_id }}</span>
        </div>

        <div class="col-sm-12 row">
            <router-link tag="div" to="/register" class="btn btn-block btn-register">CREATE AN ACCOUNT</router-link>
        </div>
    </div>

    <div class="content row recover" v-else>
        <div class="col-sm-12">
            <h1><b>Sound</b>Feed</h1>
            <h2>&mdash; RECOVER PASSWORD &mdash;</h2>
        </div>

        <div class="col-sm-12 form-container">
            <div class="input-field email-field">
                <input v-model="recoveremail" @keyup.enter="recover" id="recoveremail" type="text" class="text-input" autocomplete="off">
                <label for="recoveremail" id="recoveremail-label" :data-error="getError('recoveremail')" class="input-label active">{{ emailLabel }}</label>
            </div>
        </div>

        <div class="col-sm-12">
            <div v-show="!loading" @click="recover" class="btn btn-block btn-login">RECOVER</div>
            <div v-show="loading" class="btn btn-block btn-loading disabled">
                <loader color="ripple-light" size="128px"></loader>
            </div>
        </div>

        <div class="col-sm-12">
            <p class="forgot-password">
                <a @click="isLogin = true">Back to login</a>
            </p>
            <span style="color: #0002;">{{ credentials.device_id }}</span>
        </div>

        <div class="col-sm-12 row">
            <router-link tag="div" to="/register" class="btn btn-block btn-register">CREATE AN ACCOUNT</router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            credentials: {
                email: '',
                password: '',
                // email: 'label1@example.com',
                // password: 'label1pass',
                device_id: App.OSID,
                device_type:(App.OSID ? "onesignal" : null)                
            },
            emailLabel: 'Enter your email',
            passwordLabel: 'Enter your password',
            isLogin: true,
            recoveremail: '',
            errors: [],
            loading: false,
        }
    },

    components: {
        'loader': require('@/components/Loader.vue').default,
    },    

    mounted() {
        
        // if loggedin, we logout first
        if (App.jwt){
            App.status = 'inactive';

            localStorage.removeItem('appuser');
            localStorage.removeItem('token');
            App.jwt = false;
            App.user = false;
            App.filters = false;
            App.search = false;

            if (App.allowGtag) gtag('event', 'sign_out', {
                'event_category' : 'engagement',
                'event_label' : 'Signed Out'
            });

            this.$http.delete(App.restApi + '/user/device/'+ App.OSID).then((success) => {
                this.$router.push('/login');
            }, (error) => {
                this.$router.push('/login');
            });
        }

        this.updateInputLabel();

        if (App.OSID == '853877d5-38ec-41b0-b2d3-8078621707a7' || App.OSID == '206de876-70a6-4dcb-9792-67b52eadece0'){
            this.credentials.email = 'label1@example.com';
            this.credentials.password = 'label1pass';
        }

        if (App.allowGtag) gtag('config', 'UA-152097964-2', {
            'page_title' : 'Login',
            'page_path': '/login',
            'page_location': '/login'
        });
    },

    methods: {
        login() {
            this.loading = true;

            this.$http.post(this.loginEndpoint, this.credentials).then((success) => {
                App.jwt = jwtDecode(success.data.token);

                localStorage.setItem('token', success.data.token)

                // get user data
                this.$http.get(this.userEndpoint).then((success) => {
                    var data = success.data.data;

                    App.user = {
                        songs_of_blocked_users: data.songs_of_blocked_users,
                        unread_messages_count: data.unread_messages_count,
                        not_viewed_suggestions_count: data.not_viewed_suggestions_count,
                        email: data.email,
                        id: data.id,
                        name: data.name,
                        country: data.country,
                        profile_image_direct_url: data.profile_image_direct_url,
                        settings: {
                            use_line_widget: 'line',
                            show_awesome_feedback_modal: false
                        },
                        type: data.type
                    }

                    App.allowGtag = [21,23,25,27,28,91,238,272].indexOf(App.user.id) == -1;

                     // Set the user ID using signed-in user_id.
                    if (App.allowGtag) gtag('event', 'sign_in', {
                        'event_category' : 'engagement',
                        'event_label' : 'Signed In'
                    });

                    localStorage.setItem('appuser', JSON.stringify(App.user));

                    this.$root.$emit('appNotReady');
                    // redirect to home
                    this.$router.push(App.user.type != 'Label' ? '/profile' : '/');
                }, (error) => {
                    this.errors = error.data;
                    this.loading = false;

                    $('#page-login .content').addClass('has-errors');
                });
            }, (error) => {
                this.errors = error.data;
                this.loading = false;

                $('#page-login .content').addClass('has-errors');
            });
        },

        recover() {
            this.loading = true;

            if (App.allowGtag) gtag('event', 'recover_password', {
                'event_category' : 'engagement',
                'event_label' : 'Recover password'
            });


            this.$http.post(this.recoverEndpoint, {email: this.recoveremail}).then((success) => {
                this.loading = false;
                alert('An email was sent to given email address.');
            }).catch((error) => {
                this.loading = false;
                this.errors = error.data;
            });
        },

        updateInputLabel() {
            $('#password').focus(() => {
                $('#page-login .content').removeClass('has-errors');
            }).blur(() => {
                if (this.credentials.password.length < 1) {
                    $('#password-label').removeClass('bold');
                    this.passwordLabel = 'Enter your password';
                }
            });

            $('#email').focus(() => {
                $('#page-login .content').removeClass('has-errors');
            }).blur(() => {
                if (this.credentials.email.length < 1) {
                    $('#email-label').removeClass('bold');
                    this.emailLabel = 'Enter your email';
                }
            });
        },

        inputClass(input) {
            if (this.hasError(input)) {
                return 'validate invalid';
            }
        },

        hasError(input) {
            return typeof this.errors[input] !== 'undefined';
        },

        getError(input) {
            if (!this.hasError(input)) {
                return '';
            }
            return this.errors[input][0];
        },
    },

    computed: {
        loginEndpoint() {
            return App.restApi + '/api/authorization/token';
        },

        recoverEndpoint() {
            return App.restApi + '/api/user/password-reset';
        },

        userEndpoint() {
            return App.restApi + '/api/user/' + App.jwt.user_id + '/public-info';  
        },

        passwordLabelShouldBeBold() {
            return this.credentials.password.length > 0;
        },

        emailLabelShouldBeBold() {
            return this.credentials.email.length > 0;
        },
    },

    watch: {
        errors(errorMessages) {
            if (this.hasError('email')) {
                $('#email').addClass('validate')
                    .removeClass('valid')
                    .addClass('invalid');
            }

            if (this.hasError('password')) {
                $('#password').addClass('validate')
                    .removeClass('valid')
                    .addClass('invalid');
            }
        },
    }
}
</script>
